// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nobd.van-field {\n  padding-left: 0;\n}\n.nobd.van-field::after {\n    border: none;\n}\n", ""]);
// Exports
module.exports = exports;
